import { post } from 'services/api';
import { RefundData, TicketRefundPostArgs } from './types';
import { getTicketRefundDetails } from './utils';

export const ticketsRefundPost = ({ refundPerTicket, description }: TicketRefundPostArgs): Promise<RefundData> =>
	post('/tickets/refund', { tickets: getTicketRefundDetails(refundPerTicket), description });
